export type TBlockType =
  'unstyled' |
  'ordered-list-item' |
  'unordered-list-item' |
  'header-one' |
  'header-two' |
  'header-three' |
  'header-four' |
  'header-five' |
  'header-six';

export type TInlineStyle = 'BOLD' | 'ITALIC' | 'UNDERLINE' | 'STRIKETHROUGH' | 'CODE';

export type TMediaType = 'link' | 'attachment' | 'inline-image';

export type TAdditionalType = 'personalize' | 'template';

export type TFontFamily = 'Arial' | 'Helvetica' | 'Georgia' | 'Times New Roman' | 'Courier New' | 'Verdana' | 'Trebuchet MS';

export type TFontSize = '12px' | '14px' | '16px' | '18px' | '20px' | '24px' | '28px' | '32px';

export type TTextColor = string;

export type THighlightColor = string;

export type TTextAlign = 'left' | 'center' | 'right' | 'justify';

export type TIndentType = 'indent' | 'outdent';

export interface ImageEntityData {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  alignment?: 'left' | 'center' | 'right';
}

export interface ButtonEntityData {
  text: string;
  url: string;
  style: 'primary' | 'secondary' | 'outline';
  size: 'small' | 'medium' | 'large';
}
